/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { FlexContainer, Message } from "@nordcloud/gnui";

type ErrorMessageProps = {
  error: Error;
  status?: "danger" | "notification";
  onClick?: () => void;
};

export function ErrorMessage({ error, status = "danger" }: ErrorMessageProps) {
  return (
    <Message status={status} image="danger">
      <FlexContainer align-items="space-between">
        <p>
          Sorry, something went wrong. Please try again or contact us using
          products@nordcloud.com.
          <br />
          {error?.message}
        </p>
      </FlexContainer>
    </Message>
  );
}
